"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _CategoryListItem = _interopRequireDefault(require("./CategoryListItem"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var CategoryFilterBox = function CategoryFilterBox(_ref) {
  var className = _ref.className,
      selectedCategory = _ref.selectedCategory,
      onSelect = _ref.onSelect,
      categories = _ref.categories;
  return (0, _preact.h)("div", {
    className: className
  }, (0, _preact.h)("h3", {
    className: "widget-title"
  }, (0, _preact.h)(_phrase.default, {
    p: "category.widget.title"
  })), (0, _preact.h)("ul", {
    className: "category-filter__list"
  }, (0, _preact.h)(_CategoryListItem.default, {
    selectedCategory: selectedCategory,
    title: null,
    id: null,
    onSelect: onSelect,
    isContainer: true
  }), categories.map(function (_ref2, index) {
    var title = _ref2.title,
        children = _ref2.children,
        id = _ref2.id,
        isContainer = _ref2.isContainer,
        isCollapsed = _ref2.isCollapsed;
    return (0, _preact.h)(_CategoryListItem.default, {
      key: index,
      isContainer: isContainer,
      isCollapsed: isCollapsed,
      selectedCategory: selectedCategory,
      title: title,
      id: String(id),
      onSelect: onSelect,
      childCategories: children
    });
  })));
};

var _default = CategoryFilterBox;
exports.default = _default;